import React, { FC, useState } from 'react';

import { AppCol, AppRow } from 'components/appComponents';
import { useAuth } from 'context/auth';

import { ContractorObjectItem } from 'bus/contractorObject/types';

import { ContractorObject, DriverMixerSalary, DriverSalary } from './components';

const Objects: FC = () => {
  const { getClaims }: any = useAuth();
  const [leftSelect, setLeftSelectId] = useState<Omit<ContractorObjectItem, 'contractorId'> | null>(null);

  const isCanLookDriverMixerSalaryConfiguration = getClaims(['CanLookDriverMixerSalaryConfiguration']);
  const isCanLookDriverTonarSalaryConfiguration = getClaims(['CanLookDriverTonarSalaryConfiguration']);

  return (
    <div>
      <AppRow>
        <AppCol col={4}>
          <ContractorObject onChangeSelect={setLeftSelectId} />
        </AppCol>
        <AppCol col={8}>
          {leftSelect?.type === 0 && isCanLookDriverTonarSalaryConfiguration && (
            <DriverSalary selectId={leftSelect.id!} />
          )}
          {leftSelect?.type === 1 && isCanLookDriverMixerSalaryConfiguration && (
            <DriverMixerSalary selectId={leftSelect.id!} />
          )}
        </AppCol>
      </AppRow>
    </div>
  );
};

export default Objects;
